"use strict";
/**
 * Ось A — ТИР ДОВЕРИЯ (RBAC-1 AD-3, RBAC-1.7).
 *
 * Лестница из трёх ступеней: насколько мы уверены, что за аккаунтом настоящий человек.
 * Ровно одна ступень активна у аккаунта в каждый момент, и назначает её автомат — из
 * факта, которым владеет Charon, а не решение человека.
 *
 * Имя каждой ступени говорит ровно то, что про аккаунт проверено, и ничего сверх:
 *
 *   unconfirmed — регистрация состоялась, и только;
 *   confirmed   — подтверждена почта ИЛИ вход через OAuth;
 *   verified    — KYC. Ступень заведена ПУСТОЙ: ни прав, ни назначений (AD-4). Имя
 *                 занято правдой заранее — чтобы к приходу KYC не пришлось изобретать
 *                 `verified_kyc` рядом с `verified`, значащим другое.
 *
 * ⚠ Модуль знает только ось A. Ролей членства здесь нет — они в `membership`, и это
 * не форматирование, а само правило AD-1: роль НИКОГДА не отвечает на вопрос «в чьих
 * данных работает человек».
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGACY_TIER_ROLE_NAMES = exports.TIER_ROLE_VALUES = exports.TIER_ROLES = void 0;
exports.TIER_ROLES = {
    UNCONFIRMED: 'unconfirmed',
    CONFIRMED: 'confirmed',
    VERIFIED: 'verified',
};
/**
 * Ступени снизу вверх.
 *
 * ⚠ Порядок здесь — ФАКТ о лестнице (`verified` строго сильнее `confirmed`), а не
 * разрешение гейту сравнивать «не ниже такой-то». Ни один гейт в монорепо так не
 * спрашивает, и заводить такую привычку не надо: `merchants:create` живёт на праве,
 * выданном ступени, а не на неравенстве (AD-4).
 */
exports.TIER_ROLE_VALUES = Object.values(exports.TIER_ROLES);
/**
 * Имена ступеней ДО переименования RBAC-1.7 — expand-хвост, а не часть словаря.
 *
 * ⚠ ВРЕМЕННО. `customer` (= «подтвердил почту») и `unverified` (= «ещё нет») лежат в
 * проде до релиза Track C; на dev их уже нет. Пока имена живут в базе, они живут и в
 * гейтах Messenger (`MessengerRoles.ALL`/`.CUSTOMER`) и в `VerificationTierService` —
 * и сторож AC-8 обязан считать их ОБЪЯВЛЕННЫМИ, иначе он красный с первого дня, а
 * Track D оказывается подвешен за релиз Track C без всякой на то причины.
 *
 * Снимается одним удалением этого экспорта — RBAC-1.7 Task 8, после прода. Тест при
 * этом остаётся зелёным: имён не станет ни в базе, ни в гейтах, ни здесь.
 *
 * Оставленная навсегда, эта таблица превращается ровно в ту пару фантомных имён,
 * ради которых написана RBAC-1.9.
 */
exports.LEGACY_TIER_ROLE_NAMES = ['customer', 'unverified'];
